import React from 'react';
import { Helmet } from 'react-helmet';  // Importera Helmet

function Om_oss() {
  return (
    <>
    <Helmet>
        <title>Om Provalt Service AB – Kvalitet, Omtanke & Miljöfokus</title>
        <meta name="description" content="Lär känna oss på Provalt Service AB – ett lokalt serviceföretag med fokus på kvalitet, trygghet och miljömedvetna lösningar inom städ och utemiljö." />
      <link rel="canonical" href="https://provalt.se/om-oss" />
      </Helmet>
    
    <section className="p-8 max-w-4xl mx-auto">
      <h1 className="text-2xl font-bold mb-4 text-center">Om Provalt Service AB</h1>
      
      <p className="mb-6">
        Välkommen till Provalt Service AB! Vi är ett passionerat team med lång erfarenhet inom både städ- och trädgårdsbranschen.
      </p>
      
      <p className="mb-6">
        Vi är ett passionerat team med lång erfarenhet inom både städ- och trädgårdsbranschen. Under de senaste 10 åren har vi skapat skinande rena hem och arbetsplatser genom vår expertis inom städning. Parallellt har vi även över 15 års erfarenhet av att skapa och underhålla vackra trädgårdar som våra kunder älskar.
      </p>
      
      <p className="mb-6">
        Vår resa började med en vision om att kombinera högkvalitativa tjänster med en personlig touch. Tack vare vår dedikation och våra nöjda kunder har vi haft förmånen att växa och omsätta flera miljoner. Det är ett bevis på vårt engagemang för kvalitet, pålitlighet och kundnöjdhet.
      </p>
      
      <p className="mb-6">
        Hos oss står alltid kunden i fokus. Oavsett om det handlar om en stor städning, regelbundet underhåll eller att skapa en grönskande oas i din trädgård, strävar vi efter att överträffa dina förväntningar. 
      </p>

      <div className="bg-gray-100 p-4 rounded mb-6">
        <h3 className="font-semibold mb-2">Vårt engagemang</h3>
        <p>
          Vi arbetar alltid nära våra kunder för att förstå deras unika behov och önskemål. Genom vår erfarenhet och expertis erbjuder vi skräddarsydda lösningar som passar just dig och dina krav.
        </p>
      </div>

      <div className="bg-gray-100 p-4 rounded mb-6">
        <h3 className="font-semibold mb-2">Kvalitet och miljöansvar</h3>
        <p>
          Vi strävar efter att alltid leverera tjänster av högsta kvalitet och ser till att vi arbetar med hållbara metoder och miljövänliga produkter när det är möjligt. Vi är engagerade i att bevara naturen samtidigt som vi tillhandahåller effektiva och pålitliga tjänster.
        </p>
      </div>

      <p>
        Vill du veta mer om hur vi kan hjälpa dig? Tveka inte att kontakta oss – vi ser fram emot att få bli din pålitliga partner inom städ och trädgård!
      </p>
    </section>
    </>
  );
}

export default Om_oss;
